import {PaginationState} from "app/shared/pagination/pagination.model";
import { useMutation, useQuery } from '@tanstack/react-query';
import {
  createCaseAmendment,
  fetchCaseInPreviewMode,
  searchMyCases,
  searchParticipantCases,
} from 'app/modules/pub-web-cases/service/pub-web-cases.service';
import { useNavigate } from "react-router";
import { showToast } from 'app/shared/util/toast.util';
import { toast } from 'react-toastify';
import { CasesFilter } from 'app/edozvola/cases/cases.model';

export const searchMyCasesQuery = (pagination: PaginationState, caseFilter: CasesFilter ) => {
  return useQuery({
    queryKey: ['my-cases-table', { caseFilter: caseFilter, pagination: pagination }],
    queryFn: ({ signal }) => searchMyCases({ signal, pagination, caseFilter }),
  });
};

export const searchParticipantCasesQuery = (pagination: PaginationState, caseFilter: CasesFilter) => {
  return useQuery({
    queryKey: ['participant-cases-table', { caseFilter: caseFilter, pagination: pagination }],
    queryFn: ({ signal }) => searchParticipantCases({ signal, pagination, caseFilter }),
  });
};

export const createCaseAmendmentMutation = (amendmentReturnUrl: string) => {
  const navigate = useNavigate();

  return useMutation({
    mutationFn: (idCase: number) => createCaseAmendment(idCase),
    onSuccess: result => {
      navigate(`/cases/${result}`, {state: {from: amendmentReturnUrl}});
    },
    onError: error => {
      showToast(toast.error, error.message);
    },
  });
};

export const fetchCaseInPreviewModeQuery = (idCase: number) => {
  return useQuery({
    queryKey: ['case-preview-mode', {idCase: idCase}],
    queryFn: ({ signal }) => fetchCaseInPreviewMode(idCase),
  });
};
